<template>
  <div id="view-service-suppliers">
    <v-container>
      <h1 class="mt-4">Supplier Details</h1>
      <Alert
        :showAlert="isErrorMessage"
        v-if="isErrorMessage"
        type="error"
        allowDismiss
        absolute
        :text="errorMessage"
        :inPage="false"
        :backgroundColour="true"
      />
      <ServiceSuppliersForm
        :initial-supplier="supplier"
        @save="updateSupplier"
        v-if="!isErrorMessage && supplier.supplierId"
        :is-view="true"
      />
      <Alert
        :showAlert="saveClicked.isClicked"
        :type="saveClicked.type"
        allowDismiss
        absolute
        :text="saveClicked.message"
        :inPage="false"
        :backgroundColour="true"
      />
    </v-container>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { Alert } from '@nswdoe/doe-ui-core'
import ServiceSuppliersForm from '@/views/ServiceSuppliers/form'
import { DEFAULT_SUPPLIER } from '@/constants/initial'

export default {
  name: 'UpdateServiceSuppliers',
  title: 'Update Service Suppliers - SAIS Operation UI Portal',
  components: {
    Alert,
    ServiceSuppliersForm,
  },
  data() {
    return {
      supplier: cloneDeep(DEFAULT_SUPPLIER),
      saveClicked: {
        isClicked: false,
        isSuccess: false,
        message: '',
        type: 'success',
      },
    }
  },

  async created() {
    await this.$store.dispatch('moduleSuppliers/fetchSupplier', {
      supplierId: this.$route.params.id,
    })
    this.supplier =
      this.$store.state.moduleSuppliers.selectedSupplier || cloneDeep(DEFAULT_SUPPLIER)
  },

  computed: {
    errorMessage() {
      return this.$store.state.moduleSuppliers.errorMessage
    },
    isErrorMessage() {
      const errorMessage = this.$store.state.moduleSuppliers.errorMessage
      return !!errorMessage && errorMessage.length > 0
    },
  },

  methods: {
    updateSupplier(item) {
      delete item.client
      this.$store.dispatch('moduleSuppliers/putSupplier', item).then((response) => {
        this.saveClicked = {
          isClicked: true,
          type: response.isError ? 'error' : 'success',
          isSuccess: !response.isError,
          message: response.isError
            ? response.errorMessage
            : 'The changes have been updated successfully',
        }
      })
    },
  },
}
</script>
